import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
} from "constants/ActionTypes"
import {
  message
} from "antd"
import axiosDB from 'util/ApiDB'
import setupAxiosInterceptors from "appRedux/actions/setupAxiosInterceptors";

export const ActionSendFeedback = (formData) => {
  return (dispatch, getState) => {
    dispatch({type: FETCH_START})
    const request = setupAxiosInterceptors(axiosDB, dispatch, getState);

    let newFormData = new FormData();
    if(formData['file']){
      for(var i in formData['file']){
        if(formData['file'][i]['originFileObj']){
          newFormData.append("files[]", formData['file'][i]['originFileObj'])
        }else{
          newFormData.append("files[]", formData['file'][i])
        }
      }
    }
    for(var j in formData){
      newFormData.append(j,formData[j])
    }

    request.post('feedback', newFormData).then(({data}) => {
      message.success('Feedback sent')
      dispatch({ type: FETCH_SUCCESS })
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
}